
export const promiseZoom = (map, zoom , duration) => {
  return new Promise((resolve) => {
    const onZoomEnd = () => {
      map.remove('zoomend' , onZoomEnd )
      resolve()
    }
    map.on('zoomend' , onZoomEnd )
    map.setZoom(zoom,false,duration)
  })
}

export const promiseSetZoomAndCenter = (map, zoom , p, duration) => {
  return new Promise((resolve) => {
    const onEnd = () => {
      map.remove('moveend' , onEnd )
      resolve()
    }
    map.on('moveend' , onEnd )
    map.setZoomAndCenter(zoom,p,false,duration)
  })
}
